import styled from 'styled-components';
import { Box } from '@material-ui/core';

export const IconBox = styled(Box)`
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  cursor: ${(props) => (props.disabled ? 'mouse' : 'pointer')};
`;
